<script>
	import LoginPopup from './loginPopup.svelte';
	import ApprovalPopup from './approvalPopup.svelte';
	import { popupOpen, role, email, isAuthenticated, token, showDisclaimer, signup } from "./store";
	import authenticate from "./authService";
	import Modal from './Modal.svelte';
	import Spinner from './spinner.svelte';
	import * as urls from "../json/config.json";
	import AcknowledgementPopup from './acknowledgementPopup.svelte';

	let openApproalModal = false;
	let spinner = false;
	let showReminder = false;

	const openApprove = () => {
		openApproalModal = true
		document.body.classList.add('modal-open');
	}

	const openLogin = () => {
		document.body.classList.add('modal-open');
		popupOpen.set(true)
	}

	const closeModal = () => {
		document.body.classList.remove('modal-open');
		openApproalModal = false
		popupOpen.set(false)
	};

	const logout = async() => {
		isAuthenticated.set(false)
		email.set("")
		await authenticate(process.env.LOGINUSER, process.env.PASSWORD);
	}

	async function downloadReport() {
		try{
			spinner = true
			const res = await fetch(urls.getS3report, {
				cache: "no-store",
				method: 'GET',
				headers: {
					'Authorization': 'Bearer ' + $token
				},
			});
			if (res.ok) {
				const blob = await res.blob();

				const a = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				a.download = "darkwebreport.zip";
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			} else {
				alert("Download failed! Try again or contact support.")
				throw new Error('Request failed:', res.status);
			}
			spinner = false
		}
		catch(error){
			throw new Error(error);
		}
		return true;
	}

	const loginReminder = () => {
        return `
        <div>
            <center><p>Important Reminder</center></p>

			<p>By logging in, you are accessing content that may be of a sensitive and potentially illegal nature. Remember:<p>

			<ul>
				<li>Use with Caution: You are responsible for using this information ethically and in compliance with applicable laws.</li>

				</li>Confidentiality is Paramount: Maintain the secrecy and security of all accessed information.</li>
			
				</li>Your continued access is contingent upon adherence to these guidelines.</li>
			</ul>

        </div>
        `
    }

	const subscriptionDisclaimer = () => {
        return `
		<div style="height=fit-content;">
			<center><h3><p>Subscription to Unfiltered Dark Web Reports<p></h3></center>

			<p>
				You are expressing interest in accessing unfiltered data from  our tool. 
				Due to the sensitive and potentially illegal nature of the material contained within these reports, access is strictly limited to individuals 
				working within law enforcement or organizations dedicated to the fight against Child Sexual Abuse Material (CSAM).
			</p>

			</p>Provide your email address and a member of the team will reach out to request additional information prior to approving your request.</p>

			<h4>Terms of Use:</h4>

			<ul>
				<li>Legal Compliance: You agree to use the information provided in accordance with all applicable laws and for the purpose of aiding in the fight against illegal activities, specifically CSAM.</li>

				<li>Ethical Responsibility: The content is provided to assist in legitimate investigations and efforts to combat CSAM. Any misuse of the information will result in immediate revocation of access.</li>

				<li>Confidentiality and Security: You commit to maintaining the confidentiality of the reports and to implementing appropriate security measures to prevent unauthorized access.</li>
			</ul>

			<p>
				By clicking "I Acknowledge," you confirm your understanding of the system and your commitment to abide by the terms of use. 
				You acknowledge the importance of the sensitive nature of the content and agree to proceed with the application under these conditions.
			</p>

		</div>

	`
    }

</script>

{#if $showDisclaimer}
    <div class="overlay"><AcknowledgementPopup bind:showAck={$showDisclaimer} message={subscriptionDisclaimer()} continueButtonText="I Acknowledge" showCancel={true} on:confirm={()=>$signup = true}/></div>
{/if}
        

{#if showReminder}
	<div class="overlay"><AcknowledgementPopup bind:showAck={showReminder} message={loginReminder()} continueButtonText="Accept and Continue" showCancel={true} on:confirm={openLogin}/></div>
{/if}

<div class="header">
	{#if $role == "guest"}
		<div class="text">
			Logged in as guest
		</div>
	{:else}
		<div class ="text">
			Logged in as {$email}
		</div>
	{/if}
	{#if $role != "guest" && isAuthenticated}
		<button class="login-buttons" on:click={logout}>
			Logout
		</button>
	{:else}
		<button class="login-buttons" on:click={()=>showReminder=true}>
			Login
		</button>
	{/if}
	<button class="login-buttons" on:click={downloadReport}>
		Download Report
	</button>
	{#if $role === "admin"}
		<button class="login-buttons" on:click={openApprove}>
			Approve user
		</button>
	{/if}
	{#if $popupOpen}
		<div class="overlay">
			<Modal on:close={closeModal}>
				<LoginPopup />
			</Modal>
		</div>
	{/if}
	{#if openApproalModal}
		<Modal on:close={closeModal}>
			<ApprovalPopup />
		</Modal>
	{/if}
	
</div>
<div class="spinner">
    {#if spinner === true}
        <Spinner/>
    {/if}
</div>

<style>
	.header{
		display: flex;
		flex-direction: row;
		position:sticky;
		top: 0;
		background: transparent;
		gap: 2%;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;
		width: 50vw;
		vertical-align: middle;
		float: right;
	}
	.text{
		width:fit-content;
		padding: 10px 0;
		color: ghostwhite;
		font-size: 0.9rem;
		font-family: Noto Sans Regular;
		justify-content: center;
		align-items: center;
		height: 30px;
		max-height: 30px;
	}
	.login-buttons{
		height: 30px;
		max-height: 30px;
		flex-grow: 0;
		font-size: 0.9rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 10px 15px;
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
		border-radius: 4px;
		background-image: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		color: ghostwhite;
		cursor: pointer;
		box-sizing: border-box;
	}
	.spinner{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 1000;
	}
	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(20, 5, 23, 0.5);
		z-index: 1000;
		backdrop-filter: blur(5px);;
	}
</style>